import script from "./FlirtViewChat.vue?vue&type=script&lang=ts&setup=true"
export * from "./FlirtViewChat.vue?vue&type=script&lang=ts&setup=true"

import "./FlirtViewChat.vue?vue&type=style&index=0&id=3dfec124&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3dfec124"]])

export default __exports__